import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Button, Modal } from 'semantic-ui-react'
import { getReceptoresByEmisor, clearErrors, setLocalForm, getReceptorHacienda } from '../../actions';
import { renderInput, renderSelect } from '../../util';
import { tipoIdentificacion } from '../../catalogos';
import SearchReceptor from '../search/searchReceptor';
import ReactTooltip from 'react-tooltip';

const Receptor = (props) => {

  const {
    token,
    receptoresByEmisorState,
    isLoginState,
    emisorId,
    onSelectReceptor,
    localFormState,
    receptorHaciendaState
  } = props;

  const [isActiveModal, setIsActiveModal] = useState(false);
  const [actividadesReceptor, setActividadesReceptor] = useState([]);
  const [manualActividad, setManualActividad] = useState(false);

  useEffect(() => {
    props.clearErrors();
    if (token !== null && isActiveModal) {
      props.getReceptoresByEmisor(token, emisorId);
    }
  }, [isActiveModal]);

  useEffect(() => {
    // Only populate actividadesReceptor from receptorHaciendaState when NOT in manual mode
    if (!manualActividad) {
      if (receptorHaciendaState?.actividades?.length > 0) {
        const actividadesReceptor = receptorHaciendaState?.actividades?.map(x => {
          return { value: x.codigo, display: `${x.codigo}-${x.descripcion}` };
        });
        setActividadesReceptor(actividadesReceptor);
        if(actividadesReceptor[0]?.value) {
          setReceptor("CodigoActividadReceptor", actividadesReceptor[0]?.value);
        }
      } else {
        setActividadesReceptor([]);
      }
    }
  }, [receptorHaciendaState, manualActividad]);

  const enableLoading = (isLoading) => {
    return isLoading ? 'ui active inverted dimmer' : 'ui disabled inverted dimmer';
  }

  const setReceptor = (field, value) => {
    switch (field) {
      case 'Tipo':
        props.setLocalForm({
          ...localFormState,
          Receptor: {
            ...localFormState.Receptor,
            Identificacion: {
              ...localFormState.Receptor.Identificacion,
              Tipo: value
            }
          }
        });
        break;

      case 'Numero':
        props.getReceptorHacienda(value);
        props.setLocalForm({
          ...localFormState,
          Receptor: {
            ...localFormState.Receptor,
            Identificacion: {
              ...localFormState.Receptor.Identificacion,
              Numero: value
            }
          }
        });
        break;

      case 'Nombre':
        props.setLocalForm({
          ...localFormState,
          Receptor: {
            ...localFormState.Receptor,
            Nombre: value
          }
        });
        break;

      case 'CorreoElectronico':
        props.setLocalForm({
          ...localFormState,
          Receptor: {
            ...localFormState.Receptor,
            CorreoElectronico: value
          }
        });
        break;

      case 'CodigoActividadReceptor':
        const actividadEcoReceptor = (value === '' || value?.length < 6) ? null : value;
        props.setLocalForm({
          ...localFormState,
          CodigoActividadReceptor: actividadEcoReceptor,
        });
        break;
    }
  }

  const onChangeActividadEconomica = (value) => {
    const actividadEcoReceptor = (value === '' || value?.length < 6) ? null : value;
    props.setLocalForm({
      ...localFormState,
      CodigoActividadReceptor: actividadEcoReceptor,
    });
  }

  const onToggleManualActividad = (checked) => {
    setManualActividad(checked);
    if (checked) {
      // user wants to add activity manually -> clear opciones
      setActividadesReceptor([]);
    } else {
      // restore actividades from receptorHaciendaState if available
      if (receptorHaciendaState?.actividades?.length > 0) {
        const actividades = receptorHaciendaState.actividades.map(x => ({ value: x.codigo, display: `${x.codigo}-${x.descripcion}` }));
        setActividadesReceptor(actividades);
        if(actividades[0]?.value) {
          setReceptor("CodigoActividadReceptor", actividades[0]?.value);
        }
      } else {
        setActividadesReceptor([]);
      }
    }
  }

  const nameLabel = () => (
    <>
      <label>Nombre</label>
      <i className="search icon buscar-icon" data-tip="Buscar Clientes" onClick={() => setIsActiveModal(true)}></i>< ReactTooltip />
    </>
  );

  return (
    <>
      <div className="doubling four column row">
        <div className="three wide column">
          <Field
            label="Tipo identificación"
            name="Receptor.Identificacion.Tipo"
            component={renderSelect}
            type="select"
            options={tipoIdentificacion}
            onChange={(e) => setReceptor("Tipo", e.target.value)}
          />
        </div>
        <div className="three wide column">
          <Field
            label="Cédula"
            name="Receptor.Identificacion.Numero"
            component={renderInput}
            type="text"
            maxLength="15"
            pattern="^[0-9]*$"
            onChange={(e) => setReceptor("Numero", e.target.value)}
          />
        </div>
        <div className="six wide column">
          <Field
            label={nameLabel()}
            name="Receptor.Nombre"
            component={renderInput}
            type="text"
            onChange={(e) => setReceptor("Nombre", e.target.value)}
          />
        </div>
        <div className="four wide column">
          <Field
            label="Email"
            name="Receptor.CorreoElectronico"
            component={renderInput}
            type="email"
            onChange={(e) => setReceptor("CorreoElectronico", e.target.value)}
          />
        </div>

        {/* Checkbox to toggle manual activity input */}
        <div className="eleven wide column" style={{ marginBottom: '0.3em' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5em' }}>
            <input
              type="checkbox"
              checked={manualActividad}
              onChange={(e) => onToggleManualActividad(e.target.checked)}
            />
            Agregar Actividad económica manualmente
          </label>
        </div>

        <div className="eleven wide column">
          {actividadesReceptor?.length > 0 ? <Field
            label="Actividad económica cliente"
            name="CodigoActividadReceptor"
            component={renderSelect}
            type="select"
            options={actividadesReceptor}
            onChange={(e) => onChangeActividadEconomica(e.target.value)}
          /> :
            <Field
              label="Actividad económica cliente"
              name="CodigoActividadReceptor"
              component={renderInput}
              type="text"
              onChange={(e) => setReceptor("CodigoActividadReceptor", e.target.value)}
            />}
        </div>
      </div>
      <Modal
        centered={false}
        size="small"
        open={isActiveModal}
        onClose={() => setIsActiveModal(false)}
      >
        <Modal.Header>Buscar clientes</Modal.Header>
        <Modal.Content>
          <div className={enableLoading(isLoginState)}>
            <div className="ui text loader">Loading</div>
          </div>
          <SearchReceptor
            onClick={(receptor) => {
              setIsActiveModal(false);
              onSelectReceptor(receptor);
              props.getReceptorHacienda(receptor.Identificacion.Numero);
            }
            }
            source={receptoresByEmisorState?.receptores}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button negative onClick={() => setIsActiveModal(false)}>
            Cerrar
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoginState: state.isLoginState,
    localFormState: state.localFormState,
    errorState: state.errorState,
    receptoresByEmisorState: state.receptoresByEmisorState,
    receptorHaciendaState: state.receptorHaciendaState,
  };
}

export default connect(mapStateToProps,
  {
    clearErrors,
    getReceptoresByEmisor,
    setLocalForm,
    getReceptorHacienda
  }
)(Receptor);